var exports = {
  "i5": "notificationsSection__6k5ABS",
  "WD": "spaceBannerContainer__YokM2B",
  "vK": "banner__jNsHHc",
};

module.exports = exports;
